module.exports = __webpack_public_path__ + "97fc2b2e50fbddea1d474644e955fc2b.png";